import React from 'react';
import { Form, Input, Alert } from 'antd';
import { GridLayout } from '../GridLayout';
import { SubsectionHeader } from '../SubsectionHeader';
import { SectionDivider } from '../SectionDivider';
import { spacing } from '../../design-system/tokens';

const { TextArea } = Input;

export const ContractNotesForm: React.FC = () => {
  return (
    <div>
      <Alert
        message="Review Contract Details"
        description="Please review all the information you've entered. You can add any additional notes or special terms below before creating the contract."
        type="info"
        showIcon
        style={{ marginBottom: spacing['2xl'] }}
      />

      <SubsectionHeader title="Seller Notes" />
      <Form.Item
        name="sellerNotes"
        label="Notes for Seller"
        style={{ marginTop: spacing.lg }}
      >
        <TextArea 
          rows={4} 
          placeholder="Any special instructions, terms, or notes for the seller..."
        />
      </Form.Item>

      <SectionDivider margin="xl" />

      <SubsectionHeader title="Buyer Notes" />
      <Form.Item
        name="buyerNotes"
        label="Notes for Buyer"
        style={{ marginTop: spacing.lg }}
      >
        <TextArea 
          rows={4} 
          placeholder="Any special instructions, terms, or notes for the buyer..."
        />
      </Form.Item>

      <SectionDivider margin="xl" />

      <SubsectionHeader title="Internal Notes" />
      <Form.Item
        name="internalNotes"
        label="Internal Company Notes"
        style={{ marginTop: spacing.lg }}
      >
        <TextArea 
          rows={4} 
          placeholder="Internal notes for company reference (not visible to parties)..."
        />
      </Form.Item>

      <SectionDivider margin="xl" />

      <SubsectionHeader title="Special Terms & Conditions" />
      <Form.Item
        name="specialTerms"
        label="Special Terms"
        style={{ marginTop: spacing.lg }}
      >
        <TextArea 
          rows={6} 
          placeholder="Any special terms, conditions, or clauses that should be included in the contract..."
        />
      </Form.Item>

      <Alert
        message="Contract Creation"
        description="Once you click 'Create Contract', the contract will be saved and available for shipment creation and electronic signature workflows."
        type="success"
        showIcon
        style={{ marginTop: spacing['2xl'] }}
      />
    </div>
  );
};